import { createQueryKeys } from '@lukemorales/query-key-factory'

import { getUsersPaginated } from '~/api'
import store from '~/redux'
import { getInvitationsPaginated } from '~/services/user-invitations'
import { getUserToBeEdited } from '~/services/user-permissions'
import {
  getAllHubUsersByHubIds,
  getAllPSTeamUsers,
} from '~/services/user-services'

const userId = store.getState().user?.id

export const userQueries = createQueryKeys('users', {
  searchUsers: (userFilters: Parameters<typeof getUsersPaginated>[number]) => {
    return {
      queryKey: [userFilters, { userId }],
      queryFn: async () => await getUsersPaginated(userFilters),
    }
  },
  invitationsPaginated: (
    filters: Parameters<typeof getInvitationsPaginated>[number],
  ) => ({
    queryKey: [filters, { userId }],
    queryFn: async () => await getInvitationsPaginated(filters),
  }),
  userToEdit: (userId: number) => ({
    queryKey: ['user-permissions', userId],
    queryFn: async () => await getUserToBeEdited(userId),
  }),
  allPsTeam: () => ({
    queryKey: ['ps-team-users'],
    queryFn: getAllPSTeamUsers,
  }),
  hubsByIds: (userIds: number[]) => ({
    queryKey: ['hubs-users', userIds],
    queryFn: async () => await getAllHubUsersByHubIds(userIds),
  }),
})
